export default __webpack_public_path__ + "static/media/notification.e88b6aa5.svg";